//#region
import { useState, useEffect } from 'react';
// material
import { Container, Stack, TextField, Typography, DialogActions, Button, Alert, Pagination } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import toast from 'react-hot-toast';
// components
import Page from "../components/Page";
import Loader from "./Loader";
import { RoleTable, RolePopup } from '../components/_role/tables';
import Popup from '../components/Popup';
import Controls from '../components/controls/Controls';
import { getRole, deleteRole, addRole, updateRole } from '../config/services/role';
//#endregion

export default function Role() {
    const [openPopup, setOpenPopup] = useState(false);
    const [roleList, setRoleList] = useState([]);
    const [recordForEdit, setRecordForEdit] = useState(null)
    const [roleTotalCount, setRoleListCount] = useState(0)
    const [search, setSearchValue] = useState('')
    const [sortObj, setSortObj] = useState({ sortKey: 'createdAt', sortOrder: '-1' })
    const [loader, setLoading] = useState(false)
    const [pageNo, setPagination] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [deleteObj, setDeleteObj] = useState({ dataSetId: '', dataSetName: '' })
    const [deletePopup, setDeletePopup] = useState(false)


    const addOrEdit = (request, resetForm) => {
        if (request?._id) {
            request = {
                roleId: request._id,
                roleName: request.roleName,
                userType: request.userType
            }
            updateRole(request)
                .then((res) => {
                    if (res?.data?.error?.errorMessage) {
                        toast.error(res?.data?.error?.errorMessage);
                    } else {
                        resetForm()
                        setOpenPopup(false);
                        setRecordForEdit(null)
                        fetchRoleList();
                        toast.success(res?.message)
                    }
                });
        } else {
            addRole(request)
                .then((res) => {
                    if (res?.data?.error?.errorMessage) {
                        toast.error(res?.data?.error?.errorMessage);
                    } else {
                        resetForm()
                        setOpenPopup(false);
                        setRecordForEdit(null)
                        fetchRoleList();
                        toast.success(res?.message)
                    }
                });;
        }
    }

    let totalPages = Number((roleTotalCount / itemsPerPage).toFixed(0))
    if ((totalPages * itemsPerPage) < roleTotalCount)
        totalPages = totalPages + 1;

    const fetchRoleList = () => {
        let params = { pageNo: (pageNo - 1), count: itemsPerPage, search, ...sortObj }
        setLoading(true)
        getRole(params).then((res) => {
            setRoleList(res?.result);
            setRoleListCount(res?.totalCount)
            setLoading(false)
        });
    }

    const openInPopup = roleEdit => {
        setRecordForEdit(roleEdit)
        setOpenPopup(true)
    }

    const deleteRoleF = params => {
        setDeleteObj({ roleId: params?._id, roleName: params?.roleName })
        setDeletePopup(true)
    }

    const submitDeleteRole = () => {
        let { roleId } = deleteObj
        deleteRole({ roleId })
            .then(res => {
                handleCancelDelete()
                fetchRoleList()
                toast.success(res?.message)
            })
    }

    const handlePagination = (e, pageNumber) => {
        setPagination(pageNumber)
    }

    const handleSearch = (e) => {
        let { value } = e.target
        setPagination(1)
        setSearchValue(value, () => setPagination(1))
    }


    const handleCancelDelete = () => {
        setDeletePopup(false)
        setDeleteObj({})
    }

    useEffect(() => fetchRoleList(), [search, sortObj, pageNo, itemsPerPage]);

    return (
        <>
            <Page title="Extramarks | Role ">
                <Container className='table_max_width'>
                    <Stack direction="row" alignContent="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4">
                            Role
                        </Typography>

                        <Stack direction="row" spacing={1} flexShrink={0} sx={{ my: 1 }}>
                            <TextField
                                type="search"
                                label="Search by role name"
                                onChange={handleSearch}
                            />
                            <Controls.Button
                                text="New Role"
                                variant="contained"
                                startIcon={<AddIcon />}
                                onClick={() => { setOpenPopup(true); setRecordForEdit(null); }}
                            />


                        </Stack>
                    </Stack>
                    {loader && <Loader />}
                    {roleList?.length ? <RoleTable list={roleList} openInPopup={openInPopup} deleteRole={deleteRoleF} pageNo={pageNo} itemsPerPage={itemsPerPage} /> :
                        <Alert severity="error">No Content Available!</Alert>}
                </Container>

                <div className='center cm_pagination'>
                    <Pagination count={totalPages} variant="outlined" color="primary" onChange={handlePagination} page={pageNo} />
                </div>
            </Page>


            <Popup
                title={recordForEdit ? "Edit Role" : "Add Role"}
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
            >
                <RolePopup
                    recordForEdit={recordForEdit}
                    addOrEdit={addOrEdit}
                    setOpenPopup={setOpenPopup}
                />
            </Popup>

            <Popup title={`Are you sure to delete this Role "${deleteObj?.roleName}" ?`} openPopup={deletePopup} setOpenPopup={handleCancelDelete} onClose={false}>
                <DialogActions>
                    <Button onClick={handleCancelDelete} color="primary">Cancel</Button>
                    <Button onClick={submitDeleteRole} color="error" autoFocus>Delete</Button>
                </DialogActions>
            </Popup>
        </>
    )
}
